import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const WifiNoSignalFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M12 19.6L2 8.3C4.82 5.84 8.42 4.54 12 4.54C15.58 4.54 19.18 5.84 22 8.3L12 19.6Z" />
    </SvgIcon>
  );
});
